'use client'
import { usePathname } from 'next/navigation'
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { IAffiliateLevel } from '../types'

type AffiliateLevelProviderProps = {
  children: React.ReactNode
  data: IAffiliateLevel[] | undefined | null
  totalAffiliateCustomer: number
}

type AffiliateLevelContextType = {
  open: boolean
  handleOpen: () => void
  handleClose: () => void
  data: IAffiliateLevel[] | undefined | null
  totalAffiliateCustomer: number
}
const AffiliateLevelContext = createContext<AffiliateLevelContextType | undefined>(undefined)

export const AffiliateLevelProvider = ({ children, data, totalAffiliateCustomer }: AffiliateLevelProviderProps) => {
  const [open, setOpen] = useState(false)
  // const { data } = useQuery({
  //   queryKey: ['affiliate-level'],
  //   queryFn: async () => {
  //     const res = await getListAffLevel()
  //     return res?.data
  //   }
  // })
  const pathname = usePathname()

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  useEffect(() => {
    setOpen(false)
  }, [pathname])

  const value = useMemo(
    () => ({
      data,
      open,
      totalAffiliateCustomer,
      handleOpen,
      handleClose,
    }),
    [open, handleOpen, handleClose, data, totalAffiliateCustomer]
  )

  return <AffiliateLevelContext.Provider value={value}>{children}</AffiliateLevelContext.Provider>
}

export const useAffiliateLevelContext = () => {
  const context = useContext(AffiliateLevelContext)
  if (!context) {
    throw new Error('useAffiliateLevelContext must be used within a AffiliateLevelProvider')
  }
  return context
}
